import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useIsAgent } from "../hooks/useIsAgent";
import { useIsAdmin } from "../hooks/useIsAdmin";
import { Result, Button, Spin } from "antd";
import { AGENT_ROUTES } from "../config/agentPortal";

export const AgentGuard: React.FC = () => {
  const { isAgent, loading: agentLoading } = useIsAgent();
  const { isAdmin, loading: adminLoading } = useIsAdmin();

  if (agentLoading || adminLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (isAdmin && !isAgent) {
    return (
      <Result
        status="info"
        title="Admin account"
        subTitle="This area is for agent portal users. Use the admin dashboard instead."
        extra={
          <Button type="primary" href="/admin">
            Go to admin
          </Button>
        }
      />
    );
  }

  if (!isAgent) {
    return (
      <Result
        status="403"
        title="Agent access required"
        subTitle="Your account is not linked to an agent profile. Contact E-Freight Forwarding to get access."
        extra={
          <Button type="primary" href={AGENT_ROUTES.login}>
            Agent login
          </Button>
        }
      />
    );
  }

  return <Outlet />;
};

/** Redirect agent users away from customer routes */
export const AgentRedirectIfNeeded: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAgent, loading } = useIsAgent();
  const { isAdmin, loading: adminLoading } = useIsAdmin();

  if (loading || adminLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (isAgent && !isAdmin) {
    return <Navigate to={AGENT_ROUTES.bookings} replace />;
  }

  return <>{children}</>;
};
